var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgInfo = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 11.97,
  cy: 12,
  r: 11,
  fill: "#ffe584"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#262626",
  d: "M11.97 0a12 12 0 1 0 8.48 3.51A12 12 0 0 0 11.97 0m0 22a10 10 0 1 1 7.07-2.93A10 10 0 0 1 11.97 22"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#262626",
  d: "M12.97 10h-2v8h2ZM11.97 8a1.5 1.5 0 1 0-1.5-1.5 1.5 1.5 0 0 0 1.5 1.5"
})));
export default SvgInfo;